import Vue from "vue";
import App from "./App.vue";
import VueKonva from "vue-konva";
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store/store";
import VueClipboard from "vue-clipboard2";
import Amplify, { Auth } from "aws-amplify";
import * as AmplifyModules from "aws-amplify";
import { AmplifyPlugin } from "aws-amplify-vue";
import AWSAppSyncClient, { AUTH_TYPE } from "aws-appsync";
import aws_exports from "./aws-exports";
import i18n from "./i18n";

Amplify.configure(aws_exports);

export const client = new AWSAppSyncClient({
  url: process.env.VUE_APP_AWS_APPSYNC_ENDPOINT,
  region: process.env.VUE_APP_AWS_APPSYNC_REGION,
  auth: {
    type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
    jwtToken: async () =>
      await Auth.currentSession()
        .then((data) => data.getIdToken().getJwtToken())
        .catch((err) => err),
  },
});

Vue.config.productionTip = false;

Vue.use(VueKonva);
Vue.use(AmplifyPlugin, AmplifyModules);

VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);

window.accountIdReceivedCallback = (data) => {
  dispatchEvent(new CustomEvent("accountIdReceived", { detail: data.account }));
};

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
